import {FormattedMessage} from 'react-intl';

import {createElement, PropTypes} from 'rlink-react';
import LegacyScrollTransition from 'rlink-transitions/LegacyScrollTransition';

export default function IntroPanelOrks ({css}) {
  return (
    <LegacyScrollTransition css={css}>
      <div className={css['panel-content']}>
        <h3 className={css.top}>
          <span className={css.first}>
            <FormattedMessage
              id="ui.branding.copy.DOW3_ORKS_INTRO_PANEL_ANIMATED_TAGLINE"
              defaultMessage="orks"
              description="Animated tagline appearing on the Orks faction page." />
          </span>
        </h3>
        <hr className={css.short} />
        <p className={css.top}>
          <FormattedMessage
            id="ui.branding.copy.DOW3_ORKS_INTRO_PANEL_BODY_FIRST"
            defaultMessage="Orks are big. Orks are barbaric. Orks are brutal. Orks love battle."
            description="Paragraph description of the Orks faction." />
        </p>
        <p className={css.middle}>
          <FormattedMessage
            id="ui.branding.copy.DOW3_ORKS_INTRO_PANEL_BODY_SECOND"
            defaultMessage="With each battle they take part in, the Ork horde gains bigger guns (or what they call “more dakka”), gets hold of bigger tanks and attracts more and larger Orks. Once a big enough Warboss appears, the horde becomes a Waaagh! and rampages across the Galaxy."
            description="Paragraph description of the Orks faction. Please try to retain the usage of typographically appropriate quotation marks for your locale. Dakka, Warboss and Waaagh! are Ork words." />
        </p>
        <p className={css.bottom}>
          <FormattedMessage
            id="ui.branding.copy.ORKS_INTRO_PANEL_BODY_THIRD"
            defaultMessage="The Waaagh! is an unstoppable force, crushing all opposition before moving on to other worlds aboard their ramshackle starships."
            description="Paragraph description of the Orks faction. Waaagh! is an Ork word." />
        </p>
      </div>
    </LegacyScrollTransition>
  );
}

IntroPanelOrks.propTypes = {
  css: PropTypes.object,
};



// WEBPACK FOOTER //
// ./apps/www.dawnofwar.com/src/components/IntroPanelOrks.jsx